 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER201SHAKEHANDSANDMAKEPEACE from '@/components/0_chapter201shakehandsandmakepeace'
 import A_CHAPTER202JOINTDEMONIFICATION from '@/components/1_chapter202jointdemonification'
 import A_CHAPTER203FAMOUSTIBETANSOUTH from '@/components/2_chapter203famoustibetansouth'
 import A_CHAPTER204DONOTMENTIONITAGAIN from '@/components/3_chapter204donotmentionitagain'
 import A_CHAPTER205PROACTIVELYVISITING from '@/components/4_chapter205proactivelyvisiting'
 import A_CHAPTER206TAKEGLOBALCONTROL from '@/components/5_chapter206takeglobalcontrol'
 import A_CHAPTER207WHATDOYOUWANTMETODO from '@/components/6_chapter207whatdoyouwantmetodo'
 import A_CHAPTER208FAREWELLBYDESTINY from '@/components/7_chapter208farewellbydestiny'
 import A_CHAPTER209CHINESELILYFLOWERWITHTONGUE from '@/components/8_chapter209chineselilyflowerwithtongue'
 import A_CHAPTER210STIRRINGUPTHERIGHTANDWRONG from '@/components/9_chapter210stirringuptherightandwrong'
 import A0_CHAPTER211AVOIDINGIMPORTANTSITUATIONSANDAVOIDINGSERIOUSPROBLEMS from '@/components/10_chapter211avoidingimportantsituationsandavoidingseriousproblems'
 import A1_CHAPTER212SAVIORSHEART from '@/components/11_chapter212saviorsheart'
 import A2_CHAPTER213BODYTEST from '@/components/12_chapter213bodytest'
 import A3_CHAPTER214PHAGOCYTOSISOFYANGENERGY from '@/components/13_chapter214phagocytosisofyangenergy'
 import A4_CHAPTER215FALSEMOUTHGOLD from '@/components/14_chapter215falsemouthgold'
 import A5_CHAPTER216FALSEMOUTHGOLD from '@/components/15_chapter216falsemouthgold'
 import A6_CHAPTER217COVERAGEASUSUAL from '@/components/16_chapter217coverageasusual'
 import A7_CHAPTER218CARNAGE from '@/components/17_chapter218carnage'
 import A8_CHAPTER219FALLINGINTOTHEPATHOFDEMONS from '@/components/18_chapter219fallingintothepathofdemons'
 import A9_CHAPTER220ESCAPEFROMDEATH from '@/components/19_chapter220escapefromdeath'
 import A0_CHAPTER221APPRECIATION from '@/components/20_chapter221appreciation'
 import A1_CHAPTER222PRONUNCIATION from '@/components/21_chapter222pronunciation'
 import A2_CHAPTER223TRACKINGTECHNIQUE from '@/components/22_chapter223trackingtechnique'
 import A3_CHAPTER224COMPLETEOBSESSION from '@/components/23_chapter224completeobsession'
 import A4_CHAPTER225THEREWASSOMETHINGDIFFERENTABOUTTHEPERILOUSSTAR from '@/components/24_chapter225therewassomethingdifferentabouttheperilousstar'
 import A5_CHAPTER226WHITEROBEDWEIRDO from '@/components/25_chapter226whiterobedweirdo'
 import A6_CHAPTER227DISSOLVINGTHECRISIS from '@/components/26_chapter227dissolvingthecrisis'
 import A7_CHAPTER228SUFFERINGRETRIBUTION from '@/components/27_chapter228sufferingretribution'
 import A8_CHAPTER229WHOISCONTROLLING from '@/components/28_chapter229whoiscontrolling'
 import A9_CHAPTER230EXPLAINWHY from '@/components/29_chapter230explainwhy'
 import A0_CHAPTER231WISHFULTHINKING from '@/components/30_chapter231wishfulthinking'
 import A1_CHAPTER232WIDEACCEPTANCEOFDISCIPLES from '@/components/31_chapter232wideacceptanceofdisciples'
 import A2_CHAPTER233LETTEROFREPAIR from '@/components/32_chapter233letterofrepair'
 import A3_CHAPTER234KEEPALOWPROFILE from '@/components/33_chapter234keepalowprofile'
 import A4_CHAPTER235ONESTROKEOFTHEHAND from '@/components/34_chapter235onestrokeofthehand'
 import A5_CHAPTER236LEAPSANDBOUNDS from '@/components/35_chapter236leapsandbounds'
 import A6_CHAPTER237STELLARPHENOMENON from '@/components/36_chapter237stellarphenomenon'
 import A7_CHAPTER238LATENIGHTCAFETERIA from '@/components/37_chapter238latenightcafeteria'
 import A8_CHAPTER239COURTSHIP from '@/components/38_chapter239courtship'
 import A9_CHAPTER240WITHERINGRAIN from '@/components/39_chapter240witheringrain'
 import A0_CHAPTER241BECOMEANGRYFROMEMBARRASSMENT from '@/components/40_chapter241becomeangryfromembarrassment'
 import A1_CHAPTER242CRAGGYROCK from '@/components/41_chapter242craggyrock'
 import A2_CHAPTER243STONEGIANT from '@/components/42_chapter243stonegiant'
 import A3_CHAPTER244CHANGEDAY from '@/components/43_chapter244changeday'
 import A4_CHAPTER245DISMANTLINGOFARMS from '@/components/44_chapter245dismantlingofarms'
 import A5_CHAPTER246BETWEENGAINSANDLOSSES from '@/components/45_chapter246betweengainsandlosses'
 import A6_CHAPTER247PASTANDPRESENTLIFE from '@/components/46_chapter247pastandpresentlife'
 import A7_CHAPTER248SELFDECEPTION from '@/components/47_chapter248selfdeception'
 import A8_CHAPTER249SMALLACHIEVEMENTS from '@/components/48_chapter249smallachievements'
 import A9_CHAPTER250SPARRING from '@/components/49_chapter250sparring'
 import A0_CHAPTER251RETREATINTIME from '@/components/50_chapter251retreatintime'
 import A1_CHAPTER252REMINISCENCEOFTHEPAST from '@/components/51_chapter252reminiscenceofthepast'
 import A2_CHAPTER253BEMOVEDBYTHIS from '@/components/52_chapter253bemovedbythis'
 import A3_CHAPTER254MINDPRESERVATION from '@/components/53_chapter254mindpreservation'
 import A4_CHAPTER255ATTACKTHEHEARTFORTOP from '@/components/54_chapter255attacktheheartfortop'
 import A5_CHAPTER256SHINGHUANLING from '@/components/55_chapter256shinghuanling'
 import A6_CHAPTER257METAPLASTICSPACE from '@/components/56_chapter257metaplasticspace'
 import A7_CHAPTER258JOYOUSNEWS from '@/components/57_chapter258joyousnews'
 import A8_CHAPTER259REGROUPINGOFTROOPSANDHORSES from '@/components/58_chapter259regroupingoftroopsandhorses'
 import A9_CHAPTER260ARMYMEET from '@/components/59_chapter260armymeet'
 import A0_CHAPTER261PREOCCUPATION from '@/components/60_chapter261preoccupation'
 import A1_CHAPTER262LETTEROFWAR from '@/components/61_chapter262letterofwar'
 import A2_CHAPTER263SPIDERWEBTRACE from '@/components/62_chapter263spiderwebtrace'
 import A3_CHAPTER264RESTAURANTOWNER from '@/components/63_chapter264restaurantowner'
 import A4_CHAPTER265STRONGENCOUNTER from '@/components/64_chapter265strongencounter'
 import A5_CHAPTER266THEBATTLEOFTHEPEAK from '@/components/65_chapter266thebattleofthepeak'
 import A6_CHAPTER267COMMONENEMY from '@/components/66_chapter267commonenemy'
 import A7_CHAPTER268THUNDERROLLING from '@/components/67_chapter268thunderrolling'
 import A8_CHAPTER269POWEROFFAITH from '@/components/68_chapter269poweroffaith'
 import A9_CHAPTER270WOMANLYBENEVOLENCE from '@/components/69_chapter270womanlybenevolence'
 import A0_CHAPTER271TRAVELTOMALE from '@/components/70_chapter271traveltomale'
 import A1_CHAPTER272UNEASINESS from '@/components/71_chapter272uneasiness'
 import A2_CHAPTER273TIBETANDOUBLEWALL from '@/components/72_chapter273tibetandoublewall'
 import A3_CHAPTER274INTIMATECOMRADEINARMS from '@/components/73_chapter274intimatecomradeinarms'
 import A4_CHAPTER275ENVYCRANEMYSTERY from '@/components/74_chapter275envycranemystery'
 import A5_CHAPTER276DISMANTLINGPEOPLE from '@/components/75_chapter276dismantlingpeople'
 import A6_CHAPTER277ALLLIVINGTHINGSHAVEEMOTIONS from '@/components/76_chapter277alllivingthingshaveemotions'
 import A7_CHAPTER278TEMPORARYCHANGEOFDIVINATION from '@/components/77_chapter278temporarychangeofdivination'
 import A8_CHAPTER279DISCLOSURE from '@/components/78_chapter279disclosure'
 import A9_CHAPTER280SIBLINGREACTION from '@/components/79_chapter280siblingreaction'
 import A0_CHAPTER281TWOCUTSOFKNIFE from '@/components/80_chapter281twocutsofknife'
 import A1_CHAPTER282ITISDIFFICULTTOSAY from '@/components/81_chapter282itisdifficulttosay'
 import A2_CHAPTER283REENTRYINTOTHEMILITARY from '@/components/82_chapter283reentryintothemilitary'
 import A3_CHAPTER284DEATHISENOUGH from '@/components/83_chapter284deathisenough'
 import A4_CHAPTER285FORCEDLIVELIHOOD from '@/components/84_chapter285forcedlivelihood'
 import A5_CHAPTER286MEETPEER from '@/components/85_chapter286meetpeer'
 import A6_CHAPTER287PYRETICFEVER from '@/components/86_chapter287pyreticfever'
 import A7_CHAPTER288SUBDUINGTHEDEVILSNAKES from '@/components/87_chapter288subduingthedevilsnakes'
 import A8_CHAPTER289DECEIT from '@/components/88_chapter289deceit'
 import A9_CHAPTER290UNRESTRAINEDSKELETON from '@/components/89_chapter290unrestrainedskeleton'
 import A0_CHAPTER291GOBACK from '@/components/90_chapter291goback'
 import A1_CHAPTER292IDENTITYEXPOSURE from '@/components/91_chapter292identityexposure'
 import A2_CHAPTER293FORREVENGE from '@/components/92_chapter293forrevenge'
 import A3_CHAPTER294DRAGONAWAKENING from '@/components/93_chapter294dragonawakening'
 import A4_CHAPTER295CHAPTERIII from '@/components/94_chapter295chapteriii'
 import A5_CHAPTER296INNTALKS from '@/components/95_chapter296inntalks'
 import A6_CHAPTER297BOREDOMINTHEHEART from '@/components/96_chapter297boredomintheheart'
 import A7_CHAPTER298FINALHARVEST from '@/components/97_chapter298finalharvest'
 import A8_CHAPTER299DREAMAGAIN from '@/components/98_chapter299dreamagain'
 import A9_CHAPTER300DREAMSCAPE from '@/components/99_chapter300dreamscape'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter201shakehandsandmakepeace",
 			"name" : "0_chapter201shakehandsandmakepeace",
 			"component" : A_CHAPTER201SHAKEHANDSANDMAKEPEACE
 		},
 		{
 			"path" : "/1_chapter202jointdemonification",
 			"name" : "1_chapter202jointdemonification",
 			"component" : A_CHAPTER202JOINTDEMONIFICATION
 		},
 		{
 			"path" : "/2_chapter203famoustibetansouth",
 			"name" : "2_chapter203famoustibetansouth",
 			"component" : A_CHAPTER203FAMOUSTIBETANSOUTH
 		},
 		{
 			"path" : "/3_chapter204donotmentionitagain",
 			"name" : "3_chapter204donotmentionitagain",
 			"component" : A_CHAPTER204DONOTMENTIONITAGAIN
 		},
 		{
 			"path" : "/4_chapter205proactivelyvisiting",
 			"name" : "4_chapter205proactivelyvisiting",
 			"component" : A_CHAPTER205PROACTIVELYVISITING
 		},
 		{
 			"path" : "/5_chapter206takeglobalcontrol",
 			"name" : "5_chapter206takeglobalcontrol",
 			"component" : A_CHAPTER206TAKEGLOBALCONTROL
 		},
 		{
 			"path" : "/6_chapter207whatdoyouwantmetodo",
 			"name" : "6_chapter207whatdoyouwantmetodo",
 			"component" : A_CHAPTER207WHATDOYOUWANTMETODO
 		},
 		{
 			"path" : "/7_chapter208farewellbydestiny",
 			"name" : "7_chapter208farewellbydestiny",
 			"component" : A_CHAPTER208FAREWELLBYDESTINY
 		},
 		{
 			"path" : "/8_chapter209chineselilyflowerwithtongue",
 			"name" : "8_chapter209chineselilyflowerwithtongue",
 			"component" : A_CHAPTER209CHINESELILYFLOWERWITHTONGUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js